import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CategoryTabs from "../components/categorytabs/CategoryTabs";
import ScrollToTop from "../components/util/ScrollToTop";
import Seo from "../components/seo/Seo";
import whatsapp from "../components/assets/logo/whatsapp.png";
import "./css/CustomizeBlouse.css";
import { formatPrice } from "../utils/formatPrice";

export const CUSTOM_BLOUSE_PRICE = 40.00;

const loadDesigns = (context) =>
    context.keys().sort().map((key, i) => ({ id: i + 1, src: context(key) }));

const frontDesigns = loadDesigns(
    require.context("../components/assets/tailor/blouse/designs/blouse-front", false, /\.(png|jpe?g)$/i)
);
const backDesigns = loadDesigns(
    require.context("../components/assets/tailor/blouse/designs/blouse-back", false, /\.(png|jpe?g)$/i)
);

const DesignCarousel = ({ label, designs, selected, onSelect }) => {
    const trackRef = useRef(null);
    // Works for both orientations - overflow:hidden on the inactive axis still
    // honors a programmatic scroll (it only blocks manual/touch scrolling), so
    // scrolling both axes unconditionally clips the row on the hidden side.
    // Only scroll whichever axis actually has overflow to scroll through.
    const scrollBy = (direction) => {
        const track = trackRef.current;
        if (!track) return;
        const isHorizontal = track.scrollWidth > track.clientWidth;
        track.scrollBy({
            top: isHorizontal ? 0 : direction * track.clientHeight * 0.8,
            left: isHorizontal ? direction * track.clientWidth * 0.8 : 0,
            behavior: "smooth",
        });
    };

    return (
        <div className="customize-picker">
            <h1>{label}{selected ? ` - #${selected.id}` : ""}</h1>
            <div className="customize-carousel">
                <button type="button" className="customize-carousel-arrow" onClick={() => scrollBy(-1)} aria-label={`Scroll ${label} up`}>▲</button>
                <div className="customize-carousel-track" ref={trackRef}>
                    {designs.map((design) => (
                        <img
                            key={design.id}
                            src={design.src}
                            alt={`${label} ${design.id}`}
                            className="customize-carousel-thumb"
                            style={{ borderColor: design.id === selected?.id ? "#f4511e" : "transparent" }}
                            onClick={() => onSelect(design)}
                        />
                    ))}
                </div>
                <button type="button" className="customize-carousel-arrow" onClick={() => scrollBy(1)} aria-label={`Scroll ${label} down`}>▼</button>
            </div>
        </div>
    );
};

const CustomizeBlouse = () => {
    const navigate = useNavigate();
    const [selectedFront, setSelectedFront] = useState(frontDesigns[0]);
    const [selectedBack, setSelectedBack] = useState(backDesigns[0]);

    const orderLabel = `Connect~Custom Blouse~Front #${selectedFront.id}~Back #${selectedBack.id}`;
    const whatsappMessage = encodeURIComponent(orderLabel);

    return (
        <div>
            <Seo
                title="Design Your Blouse"
                description="Design your custom blouse - pick front and back Aari work patterns. Stitched to order in East Brunswick, NJ."
                path="/tailor/design-your-blouse"
            />
            <ScrollToTop />
            <CategoryTabs category="tailoring" activeTab="blouse" onSelect={(tab) => navigate(`/tailor?tab=${tab}`)} />

            <div className="customize-blouse">
                <div className="customize-blouse-header">
                    <span className="customize-blouse-title">Design Your Blouse</span>
                    <div className="customize-blouse-price">Starting at {formatPrice(CUSTOM_BLOUSE_PRICE)}</div>
                </div>

                <div className="customize-blouse-layout">
                    <DesignCarousel label="Front" designs={frontDesigns} selected={selectedFront} onSelect={setSelectedFront} />

                    <div className="customize-preview">
                        <div>
                            <div className="customize-preview-label">Front Preview</div>
                            <img src={selectedFront.src} alt="Selected front design" />
                        </div>
                        <div>
                            <div className="customize-preview-label">Back Preview</div>
                            <img src={selectedBack.src} alt="Selected back design" />
                        </div>
                    </div>

                    <DesignCarousel label="Back" designs={backDesigns} selected={selectedBack} onSelect={setSelectedBack} />
                </div>

                <div className="customize-blouse-actions">
                    <a
                        className="customize-blouse-connect"
                        href={`https://wa.me/14249778995?text=${whatsappMessage}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span>Connect</span>
                        <img src={whatsapp} alt="" width="20px" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CustomizeBlouse;
